import { Route, Routes, useLocation } from "react-router-dom";
import Homepage from "./pages/homepage";
import BungalowPage from "./pages/bungalowPage";
import DuplexPage from "./pages/duplexPage";
import HouseDetailsPage from "./pages/houseDetailsPage";
import BuyPlansPage from "./pages/buyPlansPage";
import AdminLoginPage from "./pages/adminLoginPage";
import RootLayout from "./components/admin/RootLayout";
import AddDrawing from "./components/admin/AddDrawing";
import PaymentConfirmaationPage from "./pages/paymentConfirmaationPage";
import BungalowCategoryPage from "./pages/bungalowCategoryPage";
import DuplexCategoryPage from "./pages/duplexCategoryPage";
import AllFeaturesPage from "./pages/allFeaturesPage";
import AllProducts from "./components/admin/allProducts";
import EditDrawing from "./components/admin/editDrawing";
import ScrollToTop from "./components/scrollToTop";
import FlatPage from "./pages/flatPage";
import FlatCategoryPage from "./pages/flatCategoryPage";
import AboutUsPage from "./pages/aboutUsPage";
import ConstructionPage from "./pages/constructionPage";
import NonResidentialPage from "./pages/nonResidentialPage";
import AddConstruction from "./components/admin/addConstruction";
import AllConstructs from "./components/admin/allConstructs";
import AddPicture from "./components/admin/addPicture";
import PicturesPage from "./pages/picturesPage";
import AdminChats from "./components/admin/AdminChats";
import AllPurchasesPage from "./pages/allPurchasesPage";
import ChatWidget from "./components/chat/ChatWidget";
import RequireAuth from "./components/admin/RequireAuth";

const ADMIN_PATHS = ["/dashboard", "/all-drawings", "/add-construction", "/all-constructs", "/add-pictures", "/login", "/admin-chats", "/admin-purchases"];

const App = () => {
  const location = useLocation();
  const isAdminRoute = ADMIN_PATHS.some((p) => location.pathname.startsWith(p));

  return (
    <div>
      <Routes>
        <Route path="/add-pictures/:id" element={<RequireAuth><RootLayout><AddPicture /></RootLayout></RequireAuth>} />
        <Route path="/all-constructs" element={<RequireAuth><RootLayout><AllConstructs /></RootLayout></RequireAuth>} />
        <Route path="/pictures/:id" element={<PicturesPage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/non-residential" element={<NonResidentialPage />} />
        <Route path="/" element={<Homepage />} />
        <Route path="/payment-confirmation" element={<PaymentConfirmaationPage />} />
        <Route path="/construction" element={<ConstructionPage />} />
        <Route path="/add-construction" element={<RequireAuth><RootLayout><AddConstruction /></RootLayout></RequireAuth>} />
        <Route path="/bungalows" element={<BungalowPage />} />
        <Route path="/featured-house-plans" element={<AllFeaturesPage />} />
        <Route path="/bungalow/:category" element={<BungalowCategoryPage />} />
        <Route path="/flat/:category" element={<FlatCategoryPage />} />
        <Route path="/duplex/:category" element={<DuplexCategoryPage />} />
        <Route path="/duplex" element={<DuplexPage />} />
        <Route path="/flat" element={<FlatPage />} />
        <Route path="/house-details/:id" element={<HouseDetailsPage />} />
        <Route path="/buy-plans" element={<BuyPlansPage />} />
        <Route path="/login" element={<AdminLoginPage />} />
        <Route path="/dashboard" element={<RequireAuth><RootLayout><AddDrawing /></RootLayout></RequireAuth>} />
        <Route path="/all-drawings" element={<RequireAuth><RootLayout><AllProducts /></RootLayout></RequireAuth>} />
        <Route path="/all-drawings/edit/:id" element={<RequireAuth><RootLayout><EditDrawing /></RootLayout></RequireAuth>} />
        <Route path="/admin-chats" element={<RequireAuth><RootLayout><AdminChats /></RootLayout></RequireAuth>} />
        <Route path="/admin-purchases" element={<RequireAuth><AllPurchasesPage /></RequireAuth>} />
      </Routes>
      <ScrollToTop />
      {!isAdminRoute && <ChatWidget />}
    </div>
  );
}

export default App;
